import script from "./ProductivityTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductivityTable.vue?vue&type=script&setup=true&lang=js"

import "./ProductivityTable.vue?vue&type=style&index=0&id=2ad9d0ac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ad9d0ac"]])

export default __exports__